module.exports = __webpack_public_path__ + "img/nodataImg.cad816e3.png";